import type { ReactElement, PropsWithChildren } from 'react';

import type { StepComponentProps, StepsContainer } from 'components/Stepper';

// import SignUpStepError from './SignUpStepError';
import useStyles from './SignUp.style';

type SignUpProps<T extends StepComponentProps> = PropsWithChildren<
  T & {
    currentStep: number;
    stepsContainer: StepsContainer<T>;
  }
>;

const SignUp = (props: SignUpProps<StepComponentProps>): ReactElement => {
  const {
    currentStep,
    stepsContainer: { steps },
    updateValidation,
    pending,
    errors,
  } = props;
  const { signUpForm } = useStyles();

  const {
    component: SignUpStepComponent, // TODO: ADD = SignUpStepError,
    onNext,
    formId = '',
  } = steps[currentStep] ?? {};

  return (
    <div className={signUpForm}>
      <SignUpStepComponent
        updateValidation={updateValidation}
        onNext={onNext}
        formId={formId}
        pending={pending}
        errors={errors}
      />
    </div>
  );
};

export default SignUp;
